import { createStore } from 'vuex';
import user from './modules/user';

export default createStore({
  state: {},
  mutations: {},
  actions: {},
  modules: { user },
  getters: {
    userInfo: (state) => state.user.userInfo,
    token: (state) => state.user.token,
  },
});